import * as React  from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import toast from 'react-hot-toast';
import { postRequest } from '../../../../lib/api';
import { useEffect } from 'react';
import BreadcrumbsWrapper from '../../../../components/breadcrumbs'
// Redux imports


export default function EditTags() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm();



 
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const payload = {
        name: data?.name,
      };

      const response = await postRequest(`private/editTag/${id}`, payload);
      if (response?.status === 200) {
       // toast.success('Tag updated successfully!');
      // dispatch(updateTags(response?.data));
        reset();
        navigate('/tags');
      } else {
        //toast.error(response?.message || 'Tag update failed');
      }
    } catch (err) {
      //toast.error(err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };


    // Fetch tag details on mount and set name field
  useEffect(() => {
    const fetchTag = async () => {
      try {
        const response = await postRequest(`private/fetchTag/${id}`);
        if (response?.status === 200 && response?.data?.name) {
          setValue('name', response.data.name);
        }
      } catch (err) {
        // Optionally handle error
      }
    };
    fetchTag();
  }, [id, setValue]);

  return (
    <>
       <BreadcrumbsWrapper
                                                        items={[
                                                          { label: 'Dashboard', path: '/dashboard' },
                                                          { label: 'Tags', path: '/tags' },
                                                          { label: 'EditTags', path: '' },
                                                        
                                                         
                                                        ]}
                                                      />
                                                <br></br>
      <div className="page-header">
        <h1 className="mt-0">Edit Tag</h1>
      </div>

      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="title">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Name"
                {...register('name', { required: 'Name is required' })}
                isInvalid={!!errors.title}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" type="button" onClick={() => navigate('/tags')}>
              Cancel
            </Button>
            <Button variant="contained" className='red-bg red-button text-capitalize' type="submit" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
}
